import { useEffect, useState } from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import styled from "styled-components"
import LightColors from "../../constants/LightColors"

const TabWrapper = styled.div`
  display: grid;
  grid-gap: 0px;
  grid-template-columns: repeat(${(props) => props.tabsCount}, minmax(0, 1fr));
  place-items: center;
  border-radius: 12px;
  background-color: ${LightColors.separatorlv1};
  padding: 5px;
  margin-top: 4px;
  margin-bottom: 4px;
`

const TabItem = styled.div`
  border-radius: 10px;
  background: ${(props) => props.isSelected ? LightColors.purewhite : "transparent"};
  box-shadow: ${(props) => props.isSelected ? "0px 2px 4px 0px rgba(0, 0, 0, 0.05)" : ""};
  padding-top: 9px;
  padding-bottom: 9px;
  width: 100%;
  font-weight: 600;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
`

const BoxTabs = ({onTabSelected, tabLabels}) => {
  const location = useLocation();
  const currentQueryParams = new URLSearchParams(location.search);
  const [tabIndex, setTabIndex] = useState(parseInt(currentQueryParams.get("boxTabIndex") || 0));

  const [searchParams, _] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (onTabSelected) {
      onTabSelected(tabIndex);
    }
  }, [onTabSelected, tabIndex]);

  const selectTab = (tabIndex) => {
    setTabIndex(tabIndex);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('boxTabIndex', tabIndex);
    navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
  }

  return (
    <TabWrapper tabsCount={tabLabels.length}>
      {
        tabLabels.map((label, index) => {
          return (
            <TabItem
              key={label}
              isSelected={tabIndex === index}
              onClick={() => selectTab(index)}
            >
              {label}
            </TabItem>
          )
        })
      }
    </TabWrapper>
  )
}

export default BoxTabs;
